export class ContractAdmin {
  constructor(users?: string, first_name?: string, last_name?: string, full_name?: string) {
    this.users = users;
    this.first_name = first_name;
    this.last_name = last_name;
    this.full_name = full_name;
  }

  users: string;
  first_name: string;
  last_name: string;
  full_name: string;
}
